<a routerLink="/">
  <img src="/assets/DFL_DFB_LZ_Logo_Header@3x.png" alt="Logo der Leistungszentren" class="header-logo"/>
</a>
